<template>
    <v-card>
        <v-card-title>
            <span class="headline">Cambiar estatus pedido: {{ $_str_pad_left(pedidoId) }}</span>
        </v-card-title>
        <v-card-text>
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex
                        xs12
                        sm6
                    >
                        <v-select
                            v-model="estatus_id"
                            :items="$root.estatus_all"
                            label="Estatus"
                            required
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="$emit('form:close')"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="blue darken-1"
                :loading="is_submit"
                dark
                @click="cambiarStatus"
            >
                Cambiar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import EventBus from "../EventBus";
    import axios from 'axios';

    export default {
        name: "FormChangeStatus",
        props: {
            pedidoId: {
                type: Number,
                required: true,
                default: 0
            },
            estatusActual: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                is_submit: false,
                estatus_id: this.estatusActual
            }
        },
        computed: {},
        methods: {
            cambiarStatus() {
                this.is_submit = true;
                axios.post('/api/pedidos/cambiar-estatus/' + this.pedidoId, {estatus_id: this.estatus_id})
                    .then((responseOk) => {
                        this.is_submit = false;
                        let {data: data_response, data: {message}} = responseOk;
                        EventBus.$emit('tugarrafon:show-snackbar', {text_content: message});
                        this.$emit('form:save', data_response);
                    })
                    .catch(() => {
                        this.is_submit = false;
                        EventBus.$emit('tugarrafon:show-snackbar', {text_content: 'Ocurrió un error durante la petición'});
                    });
            }
        }
    }
</script>

<style scoped>

</style>
